import { FC, useEffect, useRef, useState } from 'react';
import { Table } from '@/components';
import { getTableColumns, getHeaderColumnsGroup } from './getTableColumns';
import { DetailedStockInfo } from '../../types';
import { tableFilters } from './tableFiters';
import styles from './DetailedStockTable.module.scss';

type DetailedStockTableProps = {
  data?: DetailedStockInfo[];
  isLoading?: boolean;
};

const DetailedStockTable: FC<DetailedStockTableProps> = ({
  data,
  isLoading,
}) => {
  const tableColumns = getTableColumns(data);
  const headerColumnsGroup = getHeaderColumnsGroup(data);

  const tableRef = useRef<HTMLDivElement>(null);
  const [visibleRows, setVisibleRows] = useState<number>(
    data ? data.length : 0
  );

  useEffect(() => {
    const tableNode = tableRef.current;
    if (!tableNode) return;
    const tbody = tableNode.querySelector('table tbody');
    if (!tbody) return;

    const updateCount = () => {
      const rows = Array.from(tbody.querySelectorAll('tr')).filter(
        (tr) => !tr.className.includes('p-datatable-emptymessage')
      );
      setVisibleRows(rows.length);
    };

    updateCount();

    const observer = new MutationObserver(updateCount);
    observer.observe(tbody, { childList: true, subtree: true });

    // eslint-disable-next-line consistent-return
    return function cleanup() {
      observer.disconnect();
    };
  }, [data, isLoading]);

  // Footer dinámico con cantidad de filas
  const footer = (
    <div style={{ textAlign: 'right', padding: '8px 16px', fontWeight: 500 }}>
      {`Filas mostradas: ${visibleRows}`}
    </div>
  );

  return (
    <div className={styles.containerListTable} ref={tableRef}>
      <Table
        columns={tableColumns}
        data={data}
        isLoading={isLoading}
        filters={tableFilters}
        filterDisplay="menu"
        headerColumnGroup={headerColumnsGroup}
        footer={footer}
      />
    </div>
  );
};

export default DetailedStockTable;
